import httpClient from './httpClient';

export interface LoginRequest {
  userName: string;
  password: string;
  totpCode?: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  accessTokenExpiry: string;
  user: {
    id: string;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    roles: string[];
  };
  requires2Fa?: boolean;
}

export const authApi = {
  login: (data: LoginRequest) =>
    httpClient.post<LoginResponse>('/auth/login', data),

  refresh: (accessToken: string, refreshToken: string) =>
    httpClient.post('/auth/refresh', { accessToken, refreshToken }),

  logout: () => httpClient.post('/auth/logout'),
};
